import React from "react";
import Skeleton from "react-loading-skeleton";
import { CategoryCardContainer } from "../../style/components/CourseCard";

const CategoryCardSkeleton = () => {
  return (
    <CategoryCardContainer>
      <div className="category-card" style={{ backgroundColor: "#f5f5f5" }}>
        <div className="title">
          <Skeleton width="70%" height={22} />
        </div>
        <div className="description">
          <Skeleton count={2} />
        </div>
      </div>
    </CategoryCardContainer>
  );
};

export default CategoryCardSkeleton;